import TransactionListTable from "./table";

const TransactionList = ({
  isAssetsOnly,
  isExpensesOnly,
}: {
  isAssetsOnly?: boolean;
  isExpensesOnly?: boolean;
}) => {
  return (
    <TransactionListTable
      isAssetsOnly={isAssetsOnly}
      isExpensesOnly={isExpensesOnly}
    />
  );
};

export default TransactionList;
